import { Controller } from "@hotwired/stimulus"

const DEBUG = true
const log = (...args) => DEBUG && console.debug("[StaffSwitchModal]", ...args)

export default class extends Controller {
  static targets = ["container"]
  static outlets = ["pin-entry"]

  connect() {
    this.boundClose = this.close.bind(this)
  }

  open() {
    log("opened")
    this.forceCloseAnyOpenDropdowns()
    this.element.classList.remove("hidden")
    document.addEventListener("keydown", this.boundClose)
    if (this.hasPinEntryOutlet) {
      this.pinEntryOutlet.open()
    } else {
      log("WARN: no pin-entry outlet found")
    }
  }

  forceCloseAnyOpenDropdowns() {
    document.querySelectorAll('[data-controller*="railsui-dropdown"]').forEach((el) => {
      const menu = el.querySelector("[data-railsui-dropdown-target='menu']")
      if (menu && !menu.classList.contains("hidden")) {
        log("regression: forcing closed dropdown that was still open")
        menu.classList.add("hidden")
        menu.setAttribute("aria-hidden", "true")
      }
    })
  }

  close(event) {
    if (event?.key && event.key !== "Escape") return
    event?.preventDefault?.()
    log("closed")
    this.element.classList.add("hidden")
    document.removeEventListener("keydown", this.boundClose)
    if (this.hasPinEntryOutlet) this.pinEntryOutlet.close()
  }

  closeBackdrop(event) {
    if (event.target === this.element) this.close()
  }

  stopPropagation(event) {
    event.stopPropagation()
  }

  onSwitchSuccess() {
    this.close()
    window.dispatchEvent(new CustomEvent("staff-switch:changed"))
  }
}
